export const radioOptions = [
  {
    id: 'MATH',
    value: 'Math',
  },
  {
    id: 'CODING',
    value: 'Coding',
  },
  {
    id: 'MATH_DEMO',
    value: 'Math Demo',
  },
  {
    id: 'CODING_DEMO',
    value: 'Coding Demo',
  },
  {
    id: 'MATH_TEACHER_EVAL',
    value: 'Math Teacher Evaluation',
  },
];

export const REVIEW_TYPE = {
  MATH: 'Math',
  CODING: 'Coding',
  MATH_DEMO: 'Math Demo',
  CODING_DEMO: 'Coding Demo',
  MATH_TEACHER_EVAL: 'Math Teacher Evaluation',
};

export const RATING_EMOJI = {
  AWESOME: '🤩',
  MEH: '😕',
  BAD: '😫',
  NA: 'NA',
};

export const SCORE = {
  RED: 0,
  AMBER: 1,
  GREEN: 2,
};

export const CLASS_TYPE = {
  MATH: 'MATH',
  CODING: 'CODING',
};

export const SHOW_STATE = {
  UNPUBLISHED: 'Reviewed and Unpublished.',
  ACKNOWLEDGED: 'Acknowledged',
  PUBLISHED: 'Reviewed and Published',
  ONGOING: 'Review In Progress',
};

export const STATE = {
  UNPUBLISHED: 'UNPUBLISHED',
  ACKNOWLEDGED: 'ACKNOWLEDGED',
  PUBLISHED: 'PUBLISHED',
  ONGOING: 'ONGOING',
};

export const BUTTON_NAME = {
  UNPUBLISHED: 'PUBLISH',
  ACKNOWLEDGED: 'UNPUBLISH',
  PUBLISHED: 'UNPUBLISH',
  ONGOING: 'PUBLISH',
};

export const buttonActions = {
  PUBLISH: 'PUBLISH',
  UNPUBLISH: 'UNPUBLISH',
  SAVE: 'SAVE',
  REVIEW_UPDATE: 'REVIEW_UPDATE',
};

export const RADIO_COLORS = {
  RED: `BITTERSWEET`,
  GREEN: `BRIGHT_GREEN`,
  AMBER: `AMBER`,
};

export const AVERAGE = {
  CELEBRATE: 'CELEBRATE',
  FLAG: 'FLAG',
  NONE: 'NONE',
};

export const COLUMN_NAMES = {
  PARAMETERS: 'Parameters',
  RATINGS: 'Ratings',
  COMMENTS: 'Comments',
};

export const averageData = {
  section_title: 'Average',
  questions: [
    {
      label: '',
      id: 's2_q1',
      type: 'checkbox',
      options: [
        {
          id: 'CELEBRATE',
          value: 'Celebrate',
        },
        {
          id: 'FLAG',
          value: 'Flag',
        },
      ],
    },
  ],
};

export const classStatus = [
  {
    label: 'PRESENT',
    value: 'P',
  },
  {
    label: 'ABSENT',
    value: 'A',
  },
];

export const classMonitoringStatus = [
  {
    label: 'Active',
    value: true,
  },
  {
    label: 'Not active',
    value: false,
  },
];

export const classType = [
  {
    label: 'REGULAR',
    value: 'REGULAR',
  },
  {
    label: 'DEMO',
    value: 'DEMO',
  },
  {
    label: 'SETUP',
    value: 'SETUP',
  },
  {
    label: 'EXTRA',
    value: 'EXTRA',
  },
  {
    label: 'TEST',
    value: 'TEST',
  },
];

export const reviewStatus = [
  {
    label: 'UNREVIEWED',
    value: 'UNREVIEWED',
  },
  {
    label: 'ONGOING',
    value: 'ONGOING',
  },
  {
    label: 'PUBLISHED',
    value: 'PUBLISHED',
  },
  {
    label: 'UNPUBLISHED',
    value: 'UNPUBLISHED',
  },
  {
    label: 'ACKNOWLEDGED',
    value: 'ACKNOWLEDGED',
  },
];

export const FORM_FIELDS_COUNT = 8;
